import { useQuery } from '@apollo/client';
import { useMemo } from 'react';

import type {
  Get_Campaign_Ids_With_Unacknowledged_NotificationQuery,
  Get_Campaign_Ids_With_Unacknowledged_NotificationQueryVariables,
} from '../../../../apis/graphql';
import { useFeatureFlags } from '../../../../hooks/useFeatureFlags';
import { GET_CAMPAIGN_IDS_WITH_UNACKNOWLEDGED_NOTIFICATION } from './queries/getUnacknowledgedNotificationIds';

type UseGetUnacknoweledgedCampaignIds = {
  unacknowledgedCampaignIds: string[];
};

export const useGetUnacknowledgedCampaignIds = (campaignsIds: string[]): UseGetUnacknoweledgedCampaignIds => {
  const flags = useFeatureFlags();

  const { data } = useQuery<
    Get_Campaign_Ids_With_Unacknowledged_NotificationQuery,
    Get_Campaign_Ids_With_Unacknowledged_NotificationQueryVariables
  >(GET_CAMPAIGN_IDS_WITH_UNACKNOWLEDGED_NOTIFICATION, {
    variables: { campaignsIds },
    skip: !flags?.traffickingNotifications || !campaignsIds.length,
  });

  const unacknowledgedCampaignIds = useMemo(() => {
    return data?.getCampaignIdsWithUnacknowledgedNotifications || [];
  }, [data]);

  return { unacknowledgedCampaignIds };
};
